var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "stack"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1975_61951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1975_61951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stack_2",
    d: "M6.61537 14V15H4.61538C4.16794 15 3.78685 14.8426 3.4721 14.5279C3.15737 14.2132 3 13.8321 3 13.3846V4.61537C3 4.16794 3.15737 3.78685 3.4721 3.4721C3.78685 3.15737 4.16794 3 4.61538 3H13.3846C13.8321 3 14.2132 3.15737 14.5279 3.4721C14.8426 3.78685 15 4.16794 15 4.61537V6.61537H14V4.61537C14 4.43589 13.9423 4.28846 13.8269 4.17307C13.7115 4.05769 13.5641 4 13.3846 4H4.61538C4.43589 4 4.28846 4.05769 4.17308 4.17307C4.05769 4.28846 4 4.43589 4 4.61537V13.3846C4 13.5641 4.05769 13.7115 4.17308 13.8269C4.28846 13.9423 4.43589 14 4.61538 14H6.61537ZM10.6154 21C10.1679 21 9.78685 20.8426 9.4721 20.5279C9.15737 20.2131 9 19.8321 9 19.3846V10.6154C9 10.1679 9.15737 9.78685 9.4721 9.4721C9.78685 9.15737 10.1679 9 10.6154 9H19.3846C19.8321 9 20.2132 9.15737 20.5279 9.4721C20.8426 9.78685 21 10.1679 21 10.6154V19.3846C21 19.8321 20.8426 20.2131 20.5279 20.5279C20.2132 20.8426 19.8321 21 19.3846 21H10.6154ZM10.6154 20H19.3846C19.5641 20 19.7115 19.9423 19.8269 19.8269C19.9423 19.7115 20 19.5641 20 19.3846V10.6154C20 10.4359 19.9423 10.2885 19.8269 10.1731C19.7115 10.0577 19.5641 10 19.3846 10H10.6154C10.4359 10 10.2885 10.0577 10.1731 10.1731C10.0577 10.2885 10 10.4359 10 10.6154V19.3846C10 19.5641 10.0577 19.7115 10.1731 19.8269C10.2885 19.9423 10.4359 20 10.6154 20Z",
    fill: "#15B79E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTypeIcon);
export default __webpack_public_path__ + "static/media/payment-type-icon.05366c6831eff9f5176972f174229a89.svg";
export { ForwardRef as ReactComponent };